module.exports = __webpack_public_path__ + "static/media/filled_bar_liquidStrip_tall.86722849.svg";